// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA0vhzmMcV5IykHXHYbsbHCChUX2b-wRnM",
  authDomain: "art-generator-5a6dd.firebaseapp.com",
  projectId: "art-generator-5a6dd",
  storageBucket: "art-generator-5a6dd.appspot.com",
  messagingSenderId: "493980432371",
  appId: "1:493980432371:web:3509dee9311bf21939c486",
  measurementId: "G-XMW7TCGS6L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth();
const db = getFirestore();

export {
  auth,
  db
}